export class GlobalConstants {
    static readonly FLOW_BEARER_KEY = 'flow.bearer';
    static readonly FLOW_CODE = 'code';
    static readonly APP_REDIRECT_URI = 'redirect_uri';
    static readonly THEME_KEY = 'theme';
    static readonly LANG_KEY = 'lang';
    static readonly AUTH_PARAMS = 'auth_params';
}

